export interface TypedError {
  error?: {
    message: string;
  };
  message?: string;
  status?: number;
}
